import {IComponentController, IComponentOptions, IScope} from "angular";
import {AccessLevelConfig} from "../../../model/AccessLevelConfig";
import {UserDto} from "../../../model/User";
import {Principle} from "../../../../brand_service/model/Principle";

export interface AccordionDialogScope extends IScope {
    accessLevelConfig: AccessLevelConfig;
    isNewUser: boolean;
    getSuperAdminFeatureTheme: () => any;
    controllButtonsDisabled: boolean;
    user: UserDto;
    loggedInUser: Principle;
}

export class AccordionUserSubscriptionComponent implements IComponentController {

    static instance :IComponentOptions = {
        template: require('./accordion.user.subscription.component.html'),
        controller: ['$scope', AccordionUserSubscriptionComponent],
        bindings: {
            'user': '<',
            'loggedInUser': '<'
        }
    };

    private user: UserDto;
    private loggedInUser: Principle;

    constructor(private $scope: AccordionDialogScope) {
    }

    $onInit = (): void => {
        let $scope = this.$scope;
        $scope.user = this.user;
        $scope.loggedInUser = this.loggedInUser;
        $scope.isNewUser = this.user.id == null;
        $scope.controllButtonsDisabled = false;
        $scope.getSuperAdminFeatureTheme = this.getSuperAdminFeatureTheme;
        $scope.accessLevelConfig = this.buildAccessLevelConfig();
    };

    getSuperAdminFeatureTheme = () => {
        if (!(this.loggedInUser.isSuperAdmin || this.loggedInUser.userType === 'Admin')) {
            return 'super-admin-only-feature';
        }
    }

    private buildAccessLevelConfig(): AccessLevelConfig {
        return {
            disabled: !(this.loggedInUser.isSuperAdmin || this.loggedInUser.userType === 'Admin'),
            isNewUser: this.$scope.isNewUser
        }
    }
}